export default __webpack_public_path__ + "static/site-shot-9c5bc1d8b56c7c5ee40a6061ebcbae07.jpg";